import { LEFT, RIGHT } from './touch-sequence';
import { transformProperty, transitionProperty, transitionEndEvent } from 'Shared/device-type';
import * as styles from './base.scss';
export default ({ touchSequence, container, overlay, isOpen, position, toggleFlyout }) => {
    let open = isOpen;
    const containerWidth = container.offsetWidth;
    let startedTouchingCloseToEdge;
    let currentX = 0;
    let followTouchRafId = null;
    let closeOffset = 0;
    const isFollowingTouch = () => {
        return followTouchRafId !== null;
    };
    const followTouch = () => {
        container.style[transitionProperty] = 'none';
        const loop = () => {
            const x = currentX - containerWidth;
            if (x !== 0) {
                container.style[transformProperty] = `translate3d(${x}px, 0, 0)`;
            }
            followTouchRafId = requestAnimationFrame(loop);
        };
        followTouchRafId = requestAnimationFrame(loop);
    };
    return {
        isOpen(bool) {
            open = bool;
        },
        onTouchStart(e) {
            const touch = e.touches[0];
            closeOffset = containerWidth - touch.pageX;
            currentX = containerWidth;
            if (position === 'left') {
                startedTouchingCloseToEdge = touchSequence.firstEvent().pageX < 40;
            }
            else {
                startedTouchingCloseToEdge = window.innerWidth - touchSequence.firstEvent().pageX < 40;
            }
        },
        onTouchEnd(e) {
            if (isFollowingTouch()) {
                cancelAnimationFrame(followTouchRafId);
                followTouchRafId = null;
                const swipeDirection = touchSequence.swipeDirection();
                if (swipeDirection === LEFT || swipeDirection === RIGHT) {
                    container.style[transitionProperty] = '';
                    container.style[transformProperty] = '';
                    let shouldCloseWhenSwipingDirection;
                    if (position === 'left') {
                        shouldCloseWhenSwipingDirection = LEFT;
                    }
                    else {
                        shouldCloseWhenSwipingDirection = RIGHT;
                    }
                    const shouldOpen = !open;
                    const shouldClose = open && touchSequence.isSwiping(shouldCloseWhenSwipingDirection);
                    if (shouldOpen || shouldClose) {
                        container.classList.toggle(styles.open);
                        /**
                         * Because there is a delay in the transitionend the overlay
                         * is visible when the mainMenu is hidden, to prevent this we will
                         * change the overlay opacity to 0.
                         */
                        overlay.firstChild.style.opacity = 0;
                        const toggleFlyoutAction = () => {
                            /**
                             * In order to prevent the stuterring we will first fire the
                             * redux toggle function after the css animation is done.
                             */
                            overlay.firstChild.style.opacity = '0.5';
                            toggleFlyout();
                            container.removeEventListener(transitionEndEvent, toggleFlyoutAction);
                        };
                        container.addEventListener(transitionEndEvent, toggleFlyoutAction);
                    }
                }
            }
        },
        onTouchMove(e) {
            const touch = e.touches[0];
            if (!open) {
                // Math.min()/Math.max() because you shouldn't be able to move the flyout further out
                // than the flyout is wide
                let openSwipeDirection;
                if (position === 'left') {
                    currentX = Math.min(containerWidth, touch.pageX);
                    openSwipeDirection = RIGHT;
                }
                else {
                    // The size of the space between the flyout and the device screen edge
                    const flyoutMargin = window.innerWidth - containerWidth;
                    currentX = Math.max(containerWidth, touch.pageX + containerWidth - flyoutMargin);
                    openSwipeDirection = LEFT;
                }
                if (!isFollowingTouch() && startedTouchingCloseToEdge && touchSequence.isSwiping(openSwipeDirection)) {
                    followTouch();
                }
            }
            else {
                const swipeDirection = touchSequence.swipeDirection();
                if (swipeDirection === LEFT || swipeDirection === RIGHT) {
                    let minOrMax;
                    if (position === 'left') {
                        minOrMax = Math.min;
                    }
                    else {
                        minOrMax = Math.max;
                    }
                    currentX = minOrMax(containerWidth, touch.pageX + closeOffset);
                    if (!isFollowingTouch()) {
                        followTouch();
                    }
                }
            }
            if (isFollowingTouch()) {
                e.preventDefault();
            }
        },
    };
};
